import { Controller } from '@hotwired/stimulus'
import { v4 as uuidv4 } from 'uuid'

// Generates a UUID v4 idempotency key once when the form connects.
// Persisted for the modal lifecycle; on re-open a fresh key is produced.
export default class extends Controller {
  static targets = ["input"]

  connect() {
    if (this.hasInputTarget && !this.inputTarget.value) {
      this.inputTarget.value = uuidv4()
    }
  }
}
